import { render, staticRenderFns } from "./sourcing.vue?vue&type=template&id=6b7d6b9c&scoped=true"
import script from "./sourcing.vue?vue&type=script&lang=js"
export * from "./sourcing.vue?vue&type=script&lang=js"
import style0 from "./sourcing.vue?vue&type=style&index=0&id=6b7d6b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d6b9c",
  null
  
)

export default component.exports